<template>
  <div>
    <div class="se-m-b-25 ft-14-333">
      当前手机号 {{ userInfo.encryptPhonenumber }}
    </div>
    <el-form ref="form" :model="form" label-width="0">
      <el-form-item v-if="type === 'phone'">
        <el-input
          v-model="form.newPhoneNumber"
          placeholder="输入新手机号"
          oninput="value=value.replace(/[^\d]/g,'')"
          :maxlength="11"
          type="text"
          size="small"
          readonly
          onfocus="this.removeAttribute('readonly')"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <div class="se-flex jcsb aic">
          <el-input
            v-model="form.code"
            placeholder="验证码"
            style="width: 64%"
            size="small"
            readonly
            onfocus="this.removeAttribute('readonly')"
          ></el-input>
          <div
            class="se-btn cp"
            :class="time ? 'disabled' : ''"
            @click="getCode"
          >
            {{ time ? `${time}s后重新获取` : "获取验证码" }}
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="type === 'password'">
        <el-input
          v-model="form.newPassword"
          type="password"
          placeholder="输入新密码，6-18位数字、字母组合密码"
          size="small"
          readonly
          onfocus="this.removeAttribute('readonly')"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="type === 'password'">
        <el-input
          v-model="form.preNewPassword"
          placeholder="确认新密码"
          type="password"
          size="small"
          readonly
          onfocus="this.removeAttribute('readonly')"
        ></el-input>
      </el-form-item>
    </el-form>

    <el-button
      type="danger"
      style="width: 100%"
      v-if="type == 'phone'"
      @click="updatePhone"
      >确定</el-button
    >
    <el-button
      type="danger"
      style="width: 100%"
      v-if="type == 'password'"
      @click="resetPassword"
      >确定</el-button
    >
  </div>
</template>

<script>
let timer = null;

export default {
  props: {
    type: {
      type: String,
      default: "phone",
    },
  },

  data() {
    return {
      time: 0,
      userInfo: this.$store.state.userInfo,
      form: {
        newPhoneNumber: "",
        code: "",
        phone: "",
      },

      uuid: "",
    };
  },
  methods: {
    //重置密码
    resetPassword() {
      const {
        userInfo: { phonenumber: phone },
        form: { newPassword, preNewPassword, code },
        uuid,
      } = this;

      if (!newPassword) {
        this.$message.info("请输入新密码");
        return;
      }

      if (
        !/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,18}$/.test(newPassword)
      ) {
        this.$message.info("6-18位数字、字母组合密码");
        return;
      }

      if (newPassword !== preNewPassword) {
        this.$message.info("两次密码不一致");
        return;
      }

      if (!uuid) {
        this.$message.info("请发送验证码");
        return;
      }

      if (!code) {
        this.$message.info("请输入验证码");
        return;
      }

      const data = { phone, newPassword, code, uuid };

      this.$http.put("/server/portal/home/resetPwd", data).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.form.newPhoneNumber = "";
        this.form.phone = "";
        this.form.code = "";
        this.uuid = "";
        this.$emit("changeOk");
      });
    },

    //获取短信验证码
    async getCode() {
      if (this.time) {
        return;
      }
      const phone = this.userInfo.phonenumber;
      const res = await this.$http.get(
        "/server/portal/home/getCaptcha/" + phone
      );
      this.uuid = res.msg;
      this.time = 60;
      timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(timer);
          timer = null;
        }
      }, 1000);
    },

    //更换手机号
    updatePhone() {
      const {
        userInfo: { phonenumber: phone },
        form: { newPhoneNumber, code },
        uuid,
      } = this;

      if (!newPhoneNumber) {
        this.$message.info("请输入新手机号");
        return;
      }

      if (!uuid) {
        this.$message.info("请发送验证码");
        return;
      }

      if (!code) {
        this.$message.info("请输入验证码");
        return;
      }
      const data = { phone, newPhoneNumber, code, uuid };
      this.$http
        .put("/server/portal/personCenter/updatePhoneNumber", data)
        .then((res) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.form.newPhoneNumber = "";
          this.form.phone = "";
          this.form.code = "";
          this.uuid = "";
          this.$emit("changeOk");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.se-btn {
  width: 100px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #e44352;
  font-size: 14px;
  font-weight: 400;
  color: #e44352;
  border-radius: 4px;
}

.disabled {
  border-color: #c2bebe;
  color: #c2bebe;
  cursor: not-allowed;
}
</style>
